var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('trimoz-switch',{attrs:{"label":_vm.formattedLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"aria-label":_vm.setAriaLabel,"name":_vm.metadata.name,"checked":_vm.setValue,"data-meta-id":_vm.metadata.id,"id":_vm.metadata.name},on:{"update:checked":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }